"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var path_1 = require("./definition/path");
var Offer_1 = __importDefault(require("./page/Offer/Offer"));
var Offers_1 = __importDefault(require("./page/Offer/Offers"));
var Leaderboard_1 = __importDefault(require("./page/Leaderboard/Leaderboard"));
var WaitingPurchase_1 = __importDefault(require("./page/WaitingPurchase/WaitingPurchase"));
var PaymentSuccess_1 = __importDefault(require("./page/PaymentSuccess/PaymentSuccess"));
var PaymentFailed_1 = __importDefault(require("./page/PaymentFailed/PaymentFailed"));
var TicketPage_1 = __importDefault(require("./page/Ticket/TicketPage"));
var LineCallback_1 = __importDefault(require("./page/LineCallback/LineCallback"));
function Routing() {
    var runtimeBaseName = typeof window !== "undefined" &&
        window.location.pathname.startsWith("/marketplace/web")
        ? "/marketplace/web"
        : process.env.PUBLIC_URL;
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.RouterProvider, { router: (0, react_router_dom_1.createBrowserRouter)([
            {
                path: path_1.Page.OfferPage,
                element: (0, jsx_runtime_1.jsx)(Offer_1.default, {})
            },
            {
                path: path_1.Page.OffersPage,
                element: (0, jsx_runtime_1.jsx)(Offers_1.default, {})
            },
            {
                path: path_1.Page.LeaderboardPage,
                element: (0, jsx_runtime_1.jsx)(Leaderboard_1.default, {})
            },
            {
                path: path_1.Page.WaitingPurchasePage,
                element: (0, jsx_runtime_1.jsx)(WaitingPurchase_1.default, {})
            },
            {
                path: path_1.Page.PaymentSuccessPage,
                element: (0, jsx_runtime_1.jsx)(PaymentSuccess_1.default, {})
            },
            {
                path: path_1.Page.PaymentFailedPage,
                element: (0, jsx_runtime_1.jsx)(PaymentFailed_1.default, {})
            },
            {
                path: path_1.Page.TicketPage,
                element: (0, jsx_runtime_1.jsx)(TicketPage_1.default, {})
            },
            {
                path: "/ticket/:bucketId",
                element: (0, jsx_runtime_1.jsx)(TicketPage_1.default, {})
            },
            {
                path: path_1.Page.LineCallbackPage,
                element: (0, jsx_runtime_1.jsx)(LineCallback_1.default, {})
            },
            {
                path: "/",
                element: (0, jsx_runtime_1.jsx)(Offer_1.default, {})
            }
        ], {
            basename: runtimeBaseName
        }) }));
}
exports.default = (0, mobx_react_1.observer)(Routing);
